export const getTimestampFromStore = (store) => {
  const state = store.getState();
  const delta = state.private?.serverTime?.serverTimeDelta || 0;
  return Date.now() + delta;
};
